// inventory.service.js
import axios from "../utils/axios.wrapper";

export const getAllInventories = async () => {
  const { data } = await axios.get("/inventory");
  return data.items || data;
};

export const getInventoryById = async (id) => {
  const { data } = await axios.get(`/inventory/${id}`);
  return data;
};

export const getActiveInventories = async () => {
  const { data } = await axios.get("/inventory/active");
  return data.items || data;
};

export const getInactiveInventories = async () => {
  const { data } = await axios.get("/inventory/inactive");
  return data.items || data;
};

export const getLastInventory = async () => {
  const { data } = await axios.get("/inventory/last");
  return data;
};

export const getOpenedInventory = async () => {
  const { data } = await axios.get("/inventory/opened");
  return data;
};

export const getClosedInventories = async () => {
  const { data } = await axios.get("/inventory/closed");
  return data.items || data;
};

export const createInventoryWithStockLines = async (request) => {
  const { data } = await axios.post("/inventory/create", request);
  return data;
};

export const updateInventory = async (id, inventory) => {
  const { data } = await axios.put(`/inventory/${id}`, inventory);
  return data;
};

export const openInventory = async (id) => {
  const { data } = await axios.post(`/inventory/${id}/open`);
  return data; // { jobId, inventoryId, status, message }
};

export const closeInventory = async (id) => {
  const { data } = await axios.post(`/inventory/${id}/close`);
  return data; // { jobId, inventoryId, status, message }
};

export const softDeleteInventory = async (id) => {
  const { data } = await axios.delete(`/inventory/${id}`);
  return data;
};

export const hardDeleteInventory = async (id) => {
  const { data } = await axios.delete(`/inventory/hard/${id}`);
  return data;
};

export const inventoryService = {
  getAllInventories,
  getInventoryById,
  getActiveInventories,
  getInactiveInventories,
  getLastInventory,
  getOpenedInventory,
  getClosedInventories,
  createInventoryWithStockLines,
  updateInventory,
  openInventory,
  closeInventory,
  softDeleteInventory,
  hardDeleteInventory,
};